import { customElement } from 'lit/decorators.js';
import {
  WEB_COMPONENT_POLICY_PANEL_RELAY_COMMUNICATION_WHITELIST_TABLE
} from '../../../../../../../webcomponents.constants';
import {
  GzPolicyUiSettingsTableWebComponent
} from '../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/dataTable';
import { html, TemplateResult } from 'lit';
import {
  GRID_ITEM_FORM_ID
} from '../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/base/component/GzPolicyUiSettingsBaseGrid';
import { getTableColumns } from './grid-config';
import { WhitelistedDomainItem } from '@nirvana/shared/dtos/types/policies/common';
import { ValidationResult } from '../../../../../../../ui/gzForm/formField/types/form-validator';
import { validateDuplicates } from '../utils/validators';

@customElement(WEB_COMPONENT_POLICY_PANEL_RELAY_COMMUNICATION_WHITELIST_TABLE)
export class GzRelayCommunicationWhitelistTableWebComponent extends GzPolicyUiSettingsTableWebComponent<
  WhitelistedDomainItem,
  WhitelistedDomainItem
> {
  // bind this for access to edited row index
  protected columns = getTableColumns();

  protected renderGridItemForm(): TemplateResult {
    return html` <gz-policy-panel-relay-communication-whitelist-item
      id="${GRID_ITEM_FORM_ID}"
    ></gz-policy-panel-relay-communication-whitelist-item>`;
  }

  protected validateGridItemBeforeAdd(gridItemFormValue: WhitelistedDomainItem): ValidationResult {
    return validateDuplicates(gridItemFormValue, this.gridComponent.getFormValue());
  }

  protected validateGridItemBeforeEdit(
    oldItem: WhitelistedDomainItem,
    newItem: WhitelistedDomainItem
  ): ValidationResult {
    // skip if item is not changed
    if (newItem.name === oldItem.name) {
      return { valid: true };
    }

    return this.validateGridItemBeforeAdd(newItem);
  }
}
